import CustomerStoryVertical from "@components/BasicComponents/Cards/CustomerStory/CustomerStoryVertical"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Description from "@components/CustomTypography/Description/Description"
import Separator from "@components/CustomTypography/Separator/Separator"
import Title from "@components/CustomTypography/Title/Title"
import ButtonComponent from "@components/Theme/Button/Button"
import {getLink} from "@hooks/PagesData/getLink"
import {CustomerStoryModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./CustomersSection.module.scss"

type Props = {
	data: CustomerStoryModuleType[]
}

const CustomersSection = (props: Props) => {
	return (
		<section style={{backgroundColor: "#f5f5f5"}}>
			<ContainerWrapper>
				<Separator size={128} />

				{/* Section Title and Subtitle section */}
				{/* TODO: Make Backend Part */}
				<Separator textAlignCenter withoutMeasure>
					<Title
						content={"Customer Stories"}
						fontWeight={600}
						size={"XL"}
						type={"2"}
					/>
					<Description
						content={
							"Learn how our customers are utilising videos in their daily work"
						}
						size={"XL"}
					/>
				</Separator>
				{/* Stories Cards Part */}
				<Separator />
				<Separator
					className={styles.cardContainer}
					type={"padding"}
					withoutMeasure
				>
					{props.data.map(
						(element: CustomerStoryModuleType, index: number) => {
							if (index > 0 && index < 4) {
								return (
									<CustomerStoryVertical
										key={index}
										className={styles.cardBox}
										data={element}
										minimal
									/>
								)
							}

							return null
						},
					)}
				</Separator>
				<Separator />
				<Separator textAlignCenter withoutMeasure>
					<ButtonComponent
						buttonType={"secondary"}
						link={getLink("customerStories")}
						asLink
					>
						All Customer Stories
					</ButtonComponent>
				</Separator>
				<Separator size={128} />
			</ContainerWrapper>
		</section>
	)
}

export default CustomersSection
